import { Button, ContentTemplate, Grid, KeyValue, Link, SectionHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { makeStyles } from 'tss-react/mui';
import { Theme as AugmentedTheme } from 'web-library/theme/interface';
import RouteKey from '../../routes/key';
import { stringToLongDateAndShortTime } from '../../utils/DateUtils';
import { WithdrawalSubmittedDetails } from '../../api/candidate/exam/model';
import { WithdrawalAcknowledgementResponse } from '../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalAcknowledgement';
import { useWOGAA } from '../../hooks/wogaa';

const useStyles = makeStyles()((theme) =>
({
  viewSummaryText: {
    fontWeight: 800,
    paddingLeft: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(7),
    marginRight: theme.spacing(2),
  },
}));
const { exam } = RouteKey.child;
const { examRegistrations } = RouteKey.exam.child;

interface SubmitApplicationProps {
  withdrawalReceiptDetails: WithdrawalSubmittedDetails | WithdrawalAcknowledgementResponse;
  handleViewFullSummaryClick: () => void;
}

const SubmitApplication = ({
  withdrawalReceiptDetails,
  handleViewFullSummaryClick,
}: SubmitApplicationProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();

  const handleViewRegisteredExamClick = () => {
    history.push(`/${exam}/${examRegistrations.route}`);
  };

  const { transactionEnd } = useWOGAA('myexamsseab-6453');

    /** WOGAA complete transaction for withdrawal flow
     * */
    transactionEnd(withdrawalReceiptDetails?.applicationId);

  return (
    <ContentTemplate>
      <Grid container>
        <Grid xs={12}>
          <SectionHeader
            title={t('withdrawal->>SubmitApplication.WithdrawalDetails')}
          >
            {
              <Link
                  id="link-viewFullSummary"
                  className={classes.viewSummaryText}
                  onClick={handleViewFullSummaryClick}
              >
                {t('withdrawal->>SubmitApplication.ViewFullSummary')}
              </Link>
            }
          </SectionHeader>
        </Grid>
      </Grid>
      <Grid container>
        {withdrawalReceiptDetails && (
          <>
            <Grid xs={12}>
              <KeyValue
                keyText={t('withdrawal->>SubmitApplication.ApplicationDateTime')}
                valueText={stringToLongDateAndShortTime(withdrawalReceiptDetails.localDateTime)}
              />
            </Grid>
            <Grid xs={12}>
              <KeyValue
                id="transactionNo"
                keyText={t('withdrawal->>SubmitApplication.ApplicationId')}
                valueText={withdrawalReceiptDetails.applicationId}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Button
        id="button-withdrawal-viewRegisteredExams"
        className={classes.button}
        onClick={handleViewRegisteredExamClick}
      >
        {t('withdrawal->>SubmitApplication.ViewRegisteredExams')}
      </Button>
    </ContentTemplate>
  );
};

export default SubmitApplication;
